import React from "react";

function ContentSelectItem({ children }) {
  return <div className="content-select-item">{children}</div>;
}

export default ContentSelectItem;
